import { regionsLinks } from '@pages/sales-network/regions-clinics/RegionsLinks';
import Region from '@pages/sales-network/regions-clinics/Region';



interface RegionsClinicsProps {
	selectedRegion: string,
}


const RegionsClinics = (props: RegionsClinicsProps): JSX.Element => {
	const { selectedRegion } = props;

	return (
		<div className='regions-clinics'>

			{regionsLinks.map(x =>
				<Region
					region={x}
					selectedRegion={selectedRegion}
					key={`regions-clinics-${x.region}`} />)}
			
		</div>
	);
};

export default RegionsClinics;